import { render, staticRenderFns } from "./MomentXReportPage.vue?vue&type=template&id=67290f4c&scoped=true"
import script from "./MomentXReportPage.vue?vue&type=script&lang=js"
export * from "./MomentXReportPage.vue?vue&type=script&lang=js"
import style0 from "@/assets/scss/_appointment-report.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./MomentXReportPage.vue?vue&type=style&index=1&id=67290f4c&prod&lang=scss&scoped=true"
import style2 from "./MomentXReportPage.vue?vue&type=style&index=2&id=67290f4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67290f4c",
  null
  
)

export default component.exports